export const LANGUAGE_AUTO_DETECT = "autodetect";
